import React  , {useState} from 'react';
import Input from './Input';
import ImageFile from '../../models/ImageFile'

export default function ImageFileSelector({onFileSelected}){

    const processFiles = (files) => {
        
        const file = files[0];
        const previewUrl = URL.createObjectURL(file);

        const selectedFile = ImageFile(file.name,previewUrl,file);
        console.log('imageFileSelector')
        console.log(selectedFile)
        return selectedFile;

    }

    return(
        <div>
            <input 
                type="file" 
                onChange={(e)=> {
                    
                    const selectedFile = processFiles(e.target.files);

                    if(onFileSelected){
                        onFileSelected(selectedFile);
                    }
                    
                }} 
            />
        </div>
     )
}